import { useState, useEffect } from "react";
import CategorySelect2 from "../Product/Category/CategorySelect2";
import BrandSelect2 from "../Product/Category/BrandSelect2";
import { useNavigate } from "react-router-dom";

export default function AlertStockFilterBox({ setFilterQuery, initialFilter }) {
    const navigate = useNavigate();
    const [filter, setFilter] = useState({
        status: initialFilter?.status || "unread",
        user_type: initialFilter?.user_type || "",
        type: initialFilter?.type || "",
        categories: initialFilter?.categories || [],
        brands: initialFilter?.brands || []
    });

    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState([]);

    useEffect(() => {
        setFilter({
            status: initialFilter?.status || "unread",
            user_type: initialFilter?.user_type || "",
            type: initialFilter?.type || "",
            categories: initialFilter?.categories || [],
            brands: initialFilter?.brands || []
        });
    }, [initialFilter]);

    const handleFilterChange = (name, value) => {
        setFilter(prevFilter => ({
            ...prevFilter,
            [name]: value
        }));
    };

    const handleMultiSelectCategory = (_selectedCategory) => {
        if (Array.isArray(_selectedCategory)) {
            const slugs = _selectedCategory.map(category => category.slug);
            setSelectedCategory(_selectedCategory);
            setFilter(prevFilter => ({
                ...prevFilter,
                categories: slugs
            }));
        }
    };

    const handleMultiSelectBrand = (_selectedBrand) => {
        if (Array.isArray(_selectedBrand)) {
            const values = _selectedBrand.map(brand => brand.value);
            setSelectedBrand(_selectedBrand);
            setFilter(prevFilter => ({
                ...prevFilter,
                brands: values
            }));
        }
    };

    const applyFilters = () => {
        setFilterQuery(filter);
    };

    const resetFilters = () => {
        setFilter({
            status: "unread",
            user_type: "",
            type: "",
            categories: [],
            brands: []
        });
        setFilterQuery({
            status: "unread",
            user_type: "",
            type: "",
            categories: [],
            brands: []
        });
        navigate(window.location.pathname, { replace: true });
    };

    return (
        <div>
            <div className="pt-3 pb-4">
                <div className="main-content p-3">
                    <div className="flex flex-wrap gap-3 text-xs">
                        <div>
                            <label>
                                <span className="block">وضعیت</span>
                                <select 
                                    value={filter.status}
                                    onChange={(e) => handleFilterChange("status", e.target.value)}
                                    className="bordered-input-7 bg-gray-1 w-full mt-1"
                                >   
                                    <option value="">همه</option>
                                    <option value="unread">خوانده نشده</option>
                                    <option value="read">خوانده شده</option>
                                    <option value="waiting">در انتظار</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">توسط</span>
                                <select 
                                    value={filter.user_type}
                                    onChange={(e) => handleFilterChange("user_type", e.target.value)}
                                    className="bordered-input-7 bg-gray-1 w-full mt-1"
                                >   
                                    <option value="">همه</option>
                                    <option value="employee">کارمند</option>
                                    <option value="customer">مشتری</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">از طریق</span>
                                <select 
                                    value={filter.type}
                                    onChange={(e) => handleFilterChange("type", e.target.value)}
                                    className="bordered-input-7 bg-gray-1 w-full mt-1"
                                >   
                                    <option value="">همه</option>
                                    <option value="inventory">انبارداری</option>
                                    <option value="operator">سفارش پنل</option>
                                    <option value="customer">سفارش سایت</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">دسته بندی</span>
                                <CategorySelect2
                                    assignItem={handleMultiSelectCategory}
                                    placeholder="انتخاب دسته"
                                    defaultValue={initialFilter?.categories || []}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">برند</span>
                                <BrandSelect2
                                    assignItem={handleMultiSelectBrand}
                                    placeholder="انتخاب برند"
                                    defaultValue={initialFilter?.brands || []}
                                />
                            </label>
                        </div>

                        <div className="flex gap-2">
                            <button 
                                onClick={applyFilters}
                                className="btn-orange w-full py-2"
                            >
                                اعمال فیلتر
                            </button>
                            <button 
                                onClick={resetFilters}
                                className="btn-gray w-full py-2"
                            >
                                ریست فیلتر
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}